<template>
  <div class="home-tab">
    <van-tabs :active="active" sticky @click-tab="onClickTab" title-active-color="#6A4DB9" color="#6A4DB9">
      <van-tab :title="name" v-for="name in tabList" :key="name" />
      <slot />
    </van-tabs>

  </div>
</template>


<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  emits: ["bindTabItemClickEvent"],
})
export default class NavTabs extends Vue {
  tabList: string[] = ["实时视频", "图片列表"];
  active: number = 0;

  onClickTab = (event: any) => {
    console.log("-->name: ", event.name);
    console.log("-->title: ", event.title);
    this.$emit("bindTabItemClickEvent", event.name);
  };
}
</script>

<style scoped>

.home-tab .van-tabs__line {
    background: #6A4DB9 !important;
}

</style>